import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.TermsConditionsPicker.';

  public static readonly selectTermsConditions = `${Id.prefix}selectTermsConditions`;
  public static readonly close = `${Id.prefix}close`;
}

export class LangTermsConditionsPicker {
  private constructor() {}

  public static selectTermsConditions(): string {
    return interpolate(Id.selectTermsConditions);
  }
  public static close(): string {
    return interpolate(Id.close);
  }
}

export class TermsConditionsPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.selectTermsConditions,
      "Select {{glossary 'terms-conditions'}}",
      'Dialog title for selecting terms and conditions'
    );
    register.add(Id.close, 'Close', 'Button label for closing the picker dialog');
  }
}
